import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=0696bfaa&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=0696bfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0696bfaa",
  null
  
)

export default component.exports